import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Alert,
  AlertIcon,
  useToast,
  Box,
} from '@chakra-ui/react';
import axios from 'axios';
import { standardizeError } from '../../utils';

function HelpSupport({ isOpen, onClose, email }) {
  const toast = useToast();
  const [formData, setFormData] = useState({
    email: email || '',
    content: '',
    reason: 'supporto-tecnico',
  });

  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setIsSubmitting(true);

    try {
      const response = await axios.post('/api/messages', formData);

      if (response.status === 200) {
        onClose();

        toast({
          title: 'Messaggio inviato.',
          description: 'Il tuo messaggio è stato inviato con successo.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      } else {
        setSubmitError("Errore durante l'invio del messaggio.");
      }
    } catch (err) {
      const standardizedError = standardizeError(err);

      setSubmitError(standardizedError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <form onSubmit={handleSubmit}>
        <ModalContent maxW={{ base: '90%', sm: 'md' }}>
          <ModalHeader bg="brand.100" color="black" py={4} px={6}>
            Richiesta di Supporto
          </ModalHeader>
          <ModalCloseButton variant="custom" top={4} color="white" />
          <ModalBody py={6} px={6}>
            {submitError && (
              <Alert status="error" mb={4}>
                <AlertIcon />
                {submitError}
              </Alert>
            )}
            <FormControl mb={4} isRequired>
              <FormLabel fontWeight="600">Il tuo indirizzo email</FormLabel>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                borderColor="blue.400"
              />
            </FormControl>
            <FormControl mb={4} isRequired mt={9}>
              <FormLabel fontWeight="600">Descrivi il problema</FormLabel>
              <Textarea
                name="content"
                value={formData.content}
                onChange={handleChange}
                borderColor="blue.400"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter py={4} px={6} justifyContent="flex-end">
            <Box>
              <Button variant="ghost" mr={3} onClick={onClose}>
                Chiudi
              </Button>
              <Button bg="brand.100" type="submit" isLoading={isSubmitting}>
                Invia
              </Button>
            </Box>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
}

export default HelpSupport;
